import classNames from "classnames";

interface SelectableActionProps {
  leftIcon?: string;
  leftIconCSS?: string;
  title: string;
  rightIcon?: string;
  onClick: () => void;
}

const AppSelectableAction = ({
  leftIcon,
  leftIconCSS = "",
  title,
  rightIcon = "mdi mdi-chevron-right",
  onClick,
}: SelectableActionProps) => {
  return (
    <div
      className="app-selectable-action px-2"
      style={{ fontSize: 14 }}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        {leftIcon && (
          <i
            className={classNames(leftIcon, leftIconCSS, "pr-3")}
            style={{ fontSize: 22 }}
          />
        )}
        {title}
      </div>
      <i className={classNames(rightIcon)} style={{ fontSize: 22 }} />
    </div>
  );
};

export default AppSelectableAction;
